const RESULT_TYPES = {
  CREATE: "subcontractor_create",
  SUSPEND: "subcontractor_suspend",
  DELETE: "subcontractor_delete",
  UPDATE: "subcontractor_update",
  UNSUSPEND: "subcontractor_unsuspend",
  RATE: "subcontractor_rate",
  INVITE: "subcontractor_invite",
  COMMENT: "subcontractor_comment"
}

export { RESULT_TYPES }
